import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// styles
import "./assets/scss/main.scss";
import "ant-design-vue/dist/antd.css";

declare global {
  interface Window {
    timeout: number;
  }
}

const app = createApp(App);
app.use(store).use(router).mount("#app");
